export const organisationTypes = [
  'Engineering',
  'Degree',
  'Pharmacy',
  'Pre University Course',
];

export const yearList = [
  'First Year',
  'Second Year',
  'Third Year',
  'Fourth Year',
  'Fifth Year',
];

// Hardware detail options — kept inline for hardware_details JSON object

export const workstationOS = [
  { value: 'Windows', label: 'Windows' },
  { value: 'GNU/Linux', label: 'GNU/Linux (Example: Debian, Ubuntu, Fedora)' },
  { value: 'macOS', label: 'macOS' },
];
export const workstationRAM = [
  'RAM 2GB',
  'RAM 4GB',
  'RAM 6GB',
  'RAM 8GB',
  'RAM 16GB+',
  'Not sure',
];

export const mobileOS = ['Android', 'iOS', 'Custom ROM', 'Other'];
export const mobileRAM = ['RAM 2GB', 'RAM 4GB', 'RAM 6GB', 'RAM 8GB+'];

export const internetSpeeds = [
  'Speed Below 50 Mbps',
  'Speed 50-100 Mbps',
  'Speed 100-150 Mbps',
  'Speed 150-300 Mbps',
  'Speed Above 300 Mbps',
];

export const dailyDataLimits = [
  'Data Below 500MB',
  'Data 500MB-1GB',
  'Data 1GB-1.5GB',
  'Data 1.5GB-2GB',
  'Data Above 2GB',
];
